import { useState, useRef, useEffect, useCallback } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const SliderContainer = styled.section`
  width: 100%;
  overflow: hidden;
  position: relative;
  max-height: 700px;
`;

const StyledSlides = styled.section`
  display: flex;
  transition: margin-left 0.5s ease;
`;

const StyledSlide = styled.section`
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    display: block;
  }
`;

const StyledControls = styled.section`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    background-color: #ee7d09;
    border: 0px;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px;
    padding: 0px;
    cursor: pointer;
    box-shadow: 0px 0px 10px 0px #000000;
    font-size: 15px;
    transition: width 0.5s ease;
    svg {
      color: #ffffff;
    }
    &:hover {
      width: 60px;
      transition: width 0.5s ease;
    }
    &.left {
      border-top-right-radius: 100%;
      border-bottom-right-radius: 100%;
    }
    &.right {
      border-top-left-radius: 100%;
      border-bottom-left-radius: 100%;
    }
  }
`;

const ImageSlider = ({ images, autoScroll = true, scrollTime = 10 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slideWidth, setSlideWidth] = useState(0);
  const sliderRef = useRef();
  const intervalRef = useRef();

  const updateSlideWidth = useCallback(() => {
    if (sliderRef.current) {
      setSlideWidth(sliderRef.current.offsetWidth);
    }
  }, []);

  const goToPrev = () => setCurrentIndex((i) => Math.max(i - 1, 0));

  const goToNext = () =>
    setCurrentIndex((i) => (i + 1 === images.length ? 0 : i + 1));

  useEffect(() => {
    updateSlideWidth();
    window.addEventListener("resize", updateSlideWidth);
    return () => window.removeEventListener("resize", updateSlideWidth);
  }, [updateSlideWidth]);

  useEffect(() => {
    if (autoScroll) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex + 1 === images.length ? 0 : prevIndex + 1
        );
      }, scrollTime * 1000);

      return () => clearInterval(intervalRef.current);
    }
  }, [autoScroll, scrollTime, images.length]);

  return (
    <SliderContainer ref={sliderRef}>
      <StyledSlides
        style={{
          marginLeft: `-${currentIndex * slideWidth}px`,
          width: `${images.length * slideWidth}px`,
        }}
      >
        {images.map((img, index) => (
          <StyledSlide key={index} style={{ width: `${slideWidth}px` }}>
            <img src={img} alt={`Slide ${index}`} />
          </StyledSlide>
        ))}
      </StyledSlides>
      <StyledControls>
        <button onClick={goToPrev} className="left">
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <button onClick={goToNext} className="right">
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </StyledControls>
    </SliderContainer>
  );
};

export default ImageSlider;
